import styled from "styled-components";

export const StyledSelect = styled.select`
  width: 118px;
  height: 35px;
  background: white;
  color: #000000;
  padding-left: 5px;
  font-size: 14px;
  font-weight: 400;
  border: none;
  margin-right: 45px;

  option {
    color: black;
    background: white;
    display: flex;
    white-space: pre;
    min-height: 20px;
    padding: 0px 2px 1px;
  }
`;
